module.exports = __webpack_public_path__ + "static/img/monthSuccess.68913bb.png";